// @flow
import * as React from 'react';
import Radium from 'radium';
import type { ReportState as ReportStateType } from 'types';
import { STATE_COLORS, Colors, Spacing } from 'utils/styleguide';
import { translateStateToHuman } from 'utils/text';

type Props = {
  state: ReportStateType,
};

class ReportState extends React.Component<Props> {
  render() {
    const { state } = this.props;
    const backgroundColor = STATE_COLORS[state];
    return (
      <div style={[styles.root, { backgroundColor }]}>
        {translateStateToHuman(state)}
      </div>
    );
  }
}

const styles = {
  root: {
    display: 'inline-block',
    color: Colors.White,
    paddingLeft: Spacing.Nano,
    paddingRight: Spacing.Nano,
    marginRight: Spacing.Nano,
    fontSize: 12,
    fontWeight: 'bold',
  },
};

const ReportStateContainer = Radium(ReportState);
export default ReportStateContainer;



// WEBPACK FOOTER //
// ./src/components/ReportState/ReportState.js